import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ChairLiftUsers from "../ChairLift/ChairLiftusers";

const SightUsers = () => {

  return (
    <div className="col-12">
      <ChairLiftUsers serviceId={6} Service="Sight Seeing" />
    </div>
  );
};
export default SightUsers